/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
//#endregion
//#region Services
import { userHasPermission } from "config/userPermissions";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion
import useDashboardContext from "routes/utils/context/useDashboardContext";
import { EVENTS_EXTRA_MODULES, EVENTS_MODULES } from "./utils/constants";

const Events = () => {
	const { user } = useDashboardContext();
	const userRole = user.role.id;
	//#region States
	const [routes, setRoutes] = useState(null);
	//#endregion
	//#region Effects
	useEffect(() => {
		setRoutes(getRoutes());
	}, []);
	//#endregion
	//#region Functions
	const getRoutes = () => {
		const newRoutes = [];
		EVENTS_MODULES.filter(({ id }) =>
			userHasPermission(userRole, id)
		).forEach(({ id, path, View }) => {
			newRoutes.push(
				<Route
					key={id}
					path={path}
					element={<View userRole={userRole} />}
				/>
			);
		});
		EVENTS_EXTRA_MODULES.filter(({ roles }) =>
			roles.includes(userRole)
		).forEach(({ id, path, View }) => {
			newRoutes.push(
				<Route
					key={id}
					path={path}
					element={<View userRole={userRole} />}
				/>
			);
		});
		return newRoutes;
	};
	//#endregion
	return (
		<Routes>
			{routes}
			{routes !== null && (
				<Route
					path="*"
					element={
						<Navigate
							to={ABSOLUTE_PATHS.EVENT_LIST}
							replace
						/>}
				/>
			)}
		</Routes>
	);
};

export default Events;
